import { FC, MouseEventHandler } from 'react';
import { Drawer, ModalProps, Slider } from '@material-ui/core';

import CheckIcon from 'assets/icons/ic_check.svg?url';
import CheckOnIcon from 'assets/icons/ic_check_on.svg?url';
import DistanceNearIcon from 'assets/icons/ic_distance_near.svg?url';
import DistanceFarIcon from 'assets/icons/ic_distance_far.svg?url';
import Text from 'components/Typography/Text';
import { SortingOrder, SortingOrderLabels, SortingOrderType, SortingWithDistance } from 'pages/medical-service/types';
import * as styles from './styles';

type SortingDrawerType = {
  open: boolean;
  onClose: ModalProps['onClose'];
  onSortingChanged: (sortingOrderKey: SortingOrderType) => void;
  distanceAtStep: number[];
  onSliderChangeCommitted: (event: React.ChangeEvent<{}>, value: number | number[]) => void;
  selectedDistanceStep?: number;
  selectedSortingWithDistance?: SortingWithDistance;
  defaultDistance: number;
};

const SortingDrawer: FC<SortingDrawerType> = (props) => {
  const {
    open,
    onClose,
    onSortingChanged,
    distanceAtStep,
    selectedDistanceStep,
    onSliderChangeCommitted,
    selectedSortingWithDistance,
    defaultDistance = 30,
  } = props;

  const classes = styles.useStyles();

  return (
    <Drawer className={styles.sortingDrawer} open={open} anchor="bottom" onClose={onClose}>
      <Text.Head3 className={styles.header}>정렬/거리 설정</Text.Head3>
      <div className={styles.sliderRow}>
        <div className={styles.sliderLane}>
          <img className={styles.sliderLeftIcon} src={DistanceNearIcon} alt="near distance icon" />
          <Slider
            classes={{ ...classes }}
            aria-label="Distance selection"
            defaultValue={selectedDistanceStep ?? distanceAtStep.indexOf(defaultDistance)}
            step={1}
            valueLabelDisplay="off"
            marks={distanceAtStep.map((distance, step) => ({
              value: step,
              label: `${distance}km`,
            }))}
            max={4}
            onChangeCommitted={onSliderChangeCommitted}
          />
          <img className={styles.sliderRightIcon} src={DistanceFarIcon} alt="far distance icon" />
        </div>
        <div className={styles.sliderAnnotation}>
          <Text.Body2Bold>내 주변</Text.Body2Bold>
          <Text.Body2Bold>아주 먼 곳</Text.Body2Bold>
        </div>
      </div>
      {Object.keys(SortingOrder)
        .filter((item) => ![SortingOrder.reviewCountDesc, SortingOrder.ratingMeanDesc].includes(item))
        .map((sortingOrderKey: SortingOrderType, index) => (
          <SelectableCell
            title={SortingOrderLabels[sortingOrderKey]}
            onClick={() => {
              onSortingChanged(sortingOrderKey);
            }}
            isSelected={selectedSortingWithDistance.sorting === sortingOrderKey}
            key={index}
          />
        ))}
    </Drawer>
  );
};

type SelectableCellType = {
  title: string;
  isSelected: boolean;
  onClick: MouseEventHandler;
};

const SelectableCell: FC<SelectableCellType> = (props) => {
  const { title, isSelected, onClick } = props;

  return (
    <div className={styles.selectableCellRow} onClick={onClick}>
      {isSelected ? <Text.Body1Bold>{title}</Text.Body1Bold> : <Text.Body1>{title}</Text.Body1>}
      <img src={isSelected ? CheckOnIcon : CheckIcon} alt="check icon" />
    </div>
  );
};

export default SortingDrawer;
